import DetailsDrawer from './detailsDrawer';

export default DetailsDrawer;
